import { Component, Input } from '@angular/core';

@Component({
  selector: 'common-youtube-icon',
  templateUrl: './youtube-icon.component.svg',
})
export class YoutubeIconComponent {
  @Input() color = '#343E57';
  @Input() width = 20;
  @Input() height = 14;
}
